import React from 'react';

const NotificationPreviewModal = ({ notification, onClose }) => {
    if (!notification) return null;

    return (
        <div className="notif-preview-overlay" onClick={onClose}>
            <div className="notif-preview-modal" onClick={(e) => e.stopPropagation()}>
                <div className="notif-preview-header">
                    <h6 className="notif-preview-title">{notification.title}</h6>
                    {(notification.companyName || notification.exhRegistrationNo) && (
                        <div className="notif-preview-meta">
                            {notification.companyName && (
                                <span><strong>Company Name:</strong> {notification.companyName}</span>
                            )}
                            {notification.exhRegistrationNo && (
                                <span><strong>Application No:</strong> {notification.exhRegistrationNo}</span>
                            )}
                        </div>
                    )}
                    <button className="notif-preview-close" onClick={onClose}>&times;</button>
                </div>
                <div className="notif-preview-body">
                    {notification.time && (
                        <div className="notif-preview-time">{notification.time}</div>
                    )}
                    {notification.bodyLoading ? (
                        <p className="notif-preview-message text-muted">Loading…</p>
                    ) : notification.body ? (
                        <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                    ) : (
                        <p className="notif-preview-message">{notification.title}</p>
                    )}
                </div>
            </div>
            <style>
                {`
.notif-preview-modal {
    width: 95vw;
    height: 95vh;
    max-width: none;
    max-height: none;
    border-radius: 8px;
    overflow-y: auto;
}
/* Sits beside the title in the header, pushed up against the close button. */
.notif-preview-meta {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 2px 16px;
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: #444;
    text-align: right;
}
@media (max-width: 767px) {
    .notif-preview-header {
        flex-wrap: wrap;
    }
    .notif-preview-meta {
        flex: 1 0 100%;
        justify-content: flex-start;
        text-align: left;
        order: 3;
    }
}
    `}
            </style>
        </div>
    );
};

export default NotificationPreviewModal;
